<template>
  <div id="footer">
    <div class="dFlex container">
      <div style="width: 210px;">
        <ul>
          <li class="dFlex company">
            <img src="../assets/image/f_home/logo.png" width="100%" alt="">
          </li>
        </ul>
      </div>
      <div class="flex1 ">
        <ul class="dFlex sm_soft">
          <li class="flex1">
            <img src="../assets/image/领英.png" alt="">
          </li>
          <li class=" flex1">
            <img src="../assets/image/twitter.png" alt="">
          </li>
          <li class="flex1 ">
            <img src="../assets/image/抖音.png" alt="">
          </li>
          <li class=" flex1">
            <img src="../assets/image/ins.png" alt="">
          </li>
        </ul>
      </div>
      <div class="flex1">
        <ul class="footerNews">
          <li class="dFlex">
            <div class="flexN"><img src="../assets/image/tel123.jpg" alt=""></div>
            <div class="flex1">+86 193 8197 8621</div>
          </li>
          <li class="dFlex">
            <div class="flexN"><img src="../assets/image/email123.jpg" alt=""></div>
            <div class="flex1">info@kintop-tech.com</div>
          </li>
          <li class="dFlex">
            <div class="flexN"><img src="../assets/image/whatsapp123.jpg" alt=""></div>
            <div class="flex1">+86 193 8197 8621</div>
          </li>
          <li class="dFlex">
            <div class="flexN"><img src="../assets/image/skype123.jpg" alt=""></div>
            <div class="flex1">info@kintop-tech.com</div>
          </li>
        </ul>
      </div>
      <div class="flex1">
        <div class="khFrom">
          <p>YOUR MESSAGE</p>
          <input type="text" v-model="a" placeholder="your name...">
          <input type="text" v-model="b" placeholder="your phone...">
          <input type="text" v-model="c" placeholder="your add...">
          <div class="submit">
            <input type="submit" value="SUBMIT TO" @click="addFun">
          </div>
        </div>
      </div>
    </div>
    <div class="ipTxt">
      <a href="https://beian.miit.gov.cn/" target="_blank">备案号：蜀ICP备2023019058号</a>
    </div>
  </div>
</div></template>
<script>
export default {
  name: "Footer",
  data() {
    return {
      a: '',
      b: '',
      c: '',
    };
  },
  methods: {
    addFun() {
      if (this.a == '') {
        this.$Message.error('Please enter your name')
        return
      }
      if (this.b == '') {
        this.$Message.error('Please enter your phone number')
        return
      }
      this.$Message.success("Thank you for your submission. We will contact you as soon as possible")
    }
  }
};
</script>
<style lang="scss" scoped>
.dFlex {
  display: flex;

  .flexN {
    flex: none;
  }

  .flex1 {
    flex: 1;
  }
}

.container {
  margin-left: auto;
  margin-right: auto;
  width: 1200px;
  height: 200px;
}

#footer {
  // background: #f1f1f1;
  background: #0a0a0a;
  color: #fff;
  padding: 35px 0px;
  position: relative;
  z-index: 1;
  .ipTxt{
    position:absolute;
    bottom: 3px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 12px;
    span{
      color: #eee;
      margin-right: 50px;
    }
    a{
    color: #eee;
    text-decoration: none;
    }
  }
  h1 {
    font-size: 18px;
    text-align: center;
  }

  .company {
    padding: 15px 20px;
    width: 210px;

    img {
      width: 170px;
      height: 170px;
    }
  }

  .sm_soft {
    height: 100%;
    padding: 0px 20px;
    display: flex;
    align-content: center;

    li {
      position: relative;

      img {
        display: block;
        width: 40px;
        margin: auto;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        cursor: pointer;
      }
    }
  }

  .footerNews {

    .dFlex {
      height: 55px;

      .flexN {
        display: flex;
        justify-content: center;
        align-content: center;
        width: 60px;
        margin-right: 10px;
        color: #fff;

        img {
          width: 40px;
          height: 40px;
        }
      }

      .flex1 {
        font-size: 14px;
        -webkit-line-clamp: 3;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        line-height: 40px;
      }
    }
  }

  .khFrom {
    padding: 0 20px;

    input {
      width: 100%;
      line-height: 30px;
      padding: 0px 10px;
      margin-bottom: 10px;
      border-radius: 5px;
      border: 1px solid #666;
      color: #000;
    }

    .submit {
      margin-top: 10px;

      input {
        width: 120px;
        line-height: 30px;
        padding: 0px 10px;
        margin-bottom: 10px;
        border: 1px solid #e62520;
        background: #e62520;
        color: #fff;
        border-radius: 3px;
      }
    }

    p {
      font-size: 16px;
      text-align: left;
      color: #999;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue